import { router } from '@inertiajs/react';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import InsightsRoundedIcon from '@mui/icons-material/InsightsRounded';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import * as React from 'react';

export default function HighlightedCard() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <InsightsRoundedIcon />
        <Typography
          component="h2"
          variant="subtitle2"
          gutterBottom
          sx={{ fontWeight: '600' }}
        >
          Explore seus dados
        </Typography>
        <Typography sx={{ color: 'text.secondary', mb: '8px' }}>
          Descubra insights e performance com nossa ferramenta de análise de dados.
        </Typography>
        <Button
          onClick={() => router.get('/analytics')}
          variant="contained"
          size="small"
          color="primary"
          endIcon={<ChevronRightRoundedIcon />}
          fullWidth={isSmallScreen}
          sx={{
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: isSmallScreen ? '100%' : 'auto',
            whiteSpace: 'nowrap',
            minWidth: 'max-content'
          }}
        >
          Obter insights
        </Button>
      </CardContent>
    </Card>
  );
}
